import * as Intro from 'src/styles/views/intro'
import notiImg1 from 'src/assets/images/intro/Group 4563.png'
import notiImg2 from 'src/assets/images/intro/Group 4564.png'
// import notiImg3 from 'src/assets/images/intro/Group 4565.png'
import notiImg4 from 'src/assets/images/intro/Group 4566.png'
import notiImg5 from 'src/assets/images/intro/Group 4567.png'
import notiImg6 from 'src/assets/images/intro/Group 4575.png'

export const UlContent = () => {
  return (
    <Intro.UlContentWrap>
      <Intro.Title>
        스마트피싱보호는
        <br />
        피싱사기에 대비한 기능을 제공합니다.
      </Intro.Title>
      <Intro.UlContentLayout>
        <Intro.UlContentTextWrap>
          <Intro.UlTitle>최신/주요 피싱 알림</Intro.UlTitle>
          <Intro.UlSubTitle>
            금융사기 빅데이터 수집, 분석을 통해
            <br />
            유행하는 최신 피싱 뉴스를 매주 2회
            <br />
            PUSH/MMS로 제공합니다.
          </Intro.UlSubTitle>
        </Intro.UlContentTextWrap>
        <Intro.UlImage src={notiImg1} />
      </Intro.UlContentLayout>
      <Intro.UlContentLayout>
        <Intro.UlContentTextWrap>
          <Intro.UlTitle>피싱 위험 알림</Intro.UlTitle>
          <Intro.UlSubTitle>
            피싱 의심 번호 전화 수신 시<br />
            알림을 보내고, 통화를 지속할 경우
            <br />
            단계별 알림을 보내 피해를 예방합니다.
          </Intro.UlSubTitle>
        </Intro.UlContentTextWrap>
        <Intro.UlImage src={notiImg2} />
      </Intro.UlContentLayout>
      <Intro.UlContentLayout>
        <Intro.UlContentTextWrap>
          <Intro.UlTitle>가족 피싱 알림</Intro.UlTitle>
          <Intro.UlSubTitle>
            나와 가족이 피싱 의심 번호와
            <br />
            통화 중일 때 서로 위험 알림을 받아
            <br />
            피해 예방을 도와줍니다.
          </Intro.UlSubTitle>
        </Intro.UlContentTextWrap>
        <Intro.UlImage src={notiImg4} />
      </Intro.UlContentLayout>
      <Intro.UlContentLayout>
        <Intro.UlContentTextWrap>
          <Intro.UlTitle>악성앱 탐지</Intro.UlTitle>
          <Intro.UlSubTitle>
            원격조정앱을 통한 자금 탈취,
            <br />
            전화 가로채기 앱을 통한 사칭 전화 등<br />
            금융사기에 악용되는 앱을 탐지합니다.
          </Intro.UlSubTitle>
        </Intro.UlContentTextWrap>
        <Intro.UlImage src={notiImg5} />
      </Intro.UlContentLayout>
      <Intro.UlContentLayout>
        <Intro.UlContentTextWrap>
          <Intro.UlTitle>피싱해킹보상보험</Intro.UlTitle>
          <Intro.UlSubTitle>
            피싱 사기가 발생한 경우
            <br />
            1인 1사고당 보험한도액 300만원 내<br />
            보상해 드립니다. (자기부담금 60만원 별도)
          </Intro.UlSubTitle>
        </Intro.UlContentTextWrap>
        <Intro.UlImage src={notiImg6} />
      </Intro.UlContentLayout>
    </Intro.UlContentWrap>
  )
}
